import React from "react";
import { AbsenceTypesUrl } from "../../../constants/apiUrls.js";
import DataSourceDropdownComponent from "./DataSourceDropdownComponent.js";

const AbsenceReasonsDropdown = ({
  resources,
  absenceReason,
  absenceReasons,
  onAbsenceReasonChange,
  onRequestStart,
  onRequestEnd,
  containerClass,
  helperText = null,
  defaultValue = null,
  inputName = "absencereason",
  id = "absencereason-dropdown",
  disabled = false,
  required = false,
}) => {
  return (
    <DataSourceDropdownComponent
      id={id}
      labelText={resources["Reason"]}
      value={absenceReason}
      placeholder={defaultValue ?? resources["DefaultDropdownValue"]}
      values={absenceReasons}
      handleChange={onAbsenceReasonChange}
      inputName={inputName}
      addMarginBottom={false}
      helperText={helperText}
      disabled={disabled}
      required={required}
      onRequestStart={onRequestStart}
      onRequestEnd={onRequestEnd}
      containerClass={containerClass}
      sourceUrl={AbsenceTypesUrl()}
      map={t => ({ key: t.id, name: t.description })}
      filter={a => a.isActive}
      sort={(a, b) => (a.description.toLowerCase().localeCompare(b.description.toLowerCase()))}
    />
  );
};

export default AbsenceReasonsDropdown;
